// extracted by mini-css-extract-plugin
export default {"PageController":"pageController_PageController__NWYGP","Arrow":"pageController_Arrow__5dkHK"};